
function PopupCenter(url: string, title: string, w: number = 500, h: number = 500) {
  // Fixes dual-screen position                         Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft
  const top = (height - h) / 2 / systemZoom + dualScreenTop
  const newWindow = window.open(url, title, 'scrollbars=yes, width=' + w / systemZoom + ', height=' + h / systemZoom + ', top=' + top + ', left=' + left);

  // Puts focus on the newWindow
  if (window.focus && newWindow) newWindow.focus();
}


export function facebook(url: string | null = null) {
  const _url = url ? url : window.location.href;
  // return window.open(`https://www.facebook.com/dialog/share?app_id=1737218519869880&display=popup&href=${_url}`, 'pop', 'width=600, height=400, scrollbars=no')
  return PopupCenter(`https://www.facebook.com/dialog/share?app_id=926293891227374&display=popup&href=${_url}`, 'Share on facebook');
}

export function twitter(url: string | null = null) {
  const _url = url ? url : window.location.href;
  return PopupCenter(`https://twitter.com/share?url=${_url}`, 'Share on twitter');
}


export function linkedin(url: string | null = null) {
  const _url = url ? url : window.location.href;
  return PopupCenter(`https://www.linkedin.com/shareArticle?mini=true&url=${_url}`, 'Share on linkedin');
}